import React from "react";
import style from "./Item.module.scss";
import { Button } from "antd";
import { Link, useHistory } from "react-router-dom";
import moment from "moment";

interface IItemProps {
    title: string;
    className: string;
    name: string;
    addtime: string;
    status: string;
    tid: string;
}

export default function Item(props: IItemProps) {
    const history = useHistory();

    function onClick(tid: string) {
        history.push(`/question/${tid}`);
    }

    return (
        <div className={style.root}>
            <h1 className={style.title}>
                <Link to={`/question/${props.tid}`}>{props.title}</Link>
            </h1>
            <p className={style.info}>
                {props.className}&nbsp;{props.name}&nbsp;
                <span className={style.time}>
                    {moment
                        .unix(parseInt(props.addtime.split(".")[0]))
                        .format("MM-DD HH:mm")}
                </span>
            </p>
            <div className={style.buttons}>
                {props.status === "1" && (
                    <Button
                        type="primary"
                        className={`${style.btn} ${style.btn1}`}>
                        已回答
                    </Button>
                )}
                {props.status === "0" && (
                    <Button
                        className={`${style.btn} ${style.btn3}`}
                        onClick={() => onClick(props.tid)}>
                        去回答
                    </Button>
                )}
                {props.status === "1" && (
                    <Button
                        className={`${style.btn} ${style.btn2}`}
                        onClick={() => onClick(props.tid)}>
                        编辑
                    </Button>
                )}
            </div>
        </div>
    );
}
